import nodeMarkUrl from "../../skin/brand/node-mark.jpg?url";
const RAIL_STEPS = [
    { label: "CONNECT", phase: "connect" },
    { label: "IDENTIFY", phase: "identify" },
    { label: "SECURE", phase: "secure" },
    { label: "READY", phase: "ready" },
];
const PHASE_INDEX = {
    connect: 0,
    identify: 1,
    secure: 2,
    ready: 3,
};
export class NodeOnboardingChromeElement extends HTMLElement {
    #phase = "connect";
    set phase(value) {
        this.#phase = value;
        this.#render();
    }
    get phase() {
        return this.#phase;
    }
    connectedCallback() {
        this.#render();
    }
    #render() {
        const root = this.shadowRoot ?? this.attachShadow({ mode: "open" });
        root.replaceChildren();
        const style = document.createElement("style");
        style.textContent = `
      :host { display: block; }
      header {
        display: flex; align-items: center; justify-content: space-between;
        height: 52px; padding: 0 20px;
        border-bottom: 1px solid var(--hr, rgba(10, 10, 10, 0.07));
        background: var(--bg-1, #E9E6DE);
        font-family: var(--ui-font, Inter, system-ui, sans-serif);
        color: var(--ink-hi, #0A0A0A);
      }
      .brand { display: flex; align-items: center; gap: 10px; min-width: 0; }
      .mark {
        display: block; flex-shrink: 0;
        height: 18px; width: auto;
        object-fit: contain;
      }
      .wordmark {
        font: 600 10px/1 var(--ui-mono, "JetBrains Mono", ui-monospace, monospace);
        letter-spacing: 0.14em;
      }
      .setup {
        font: 400 9.5px/1 var(--ui-mono, "JetBrains Mono", ui-monospace, monospace);
        letter-spacing: 0.14em;
        color: var(--ink-low, #888888);
      }
      nav { padding: 12px 20px; border-bottom: 1px solid var(--hr, rgba(10, 10, 10, 0.07)); }
      .rail {
        display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between;
        gap: 8px; margin: 0; padding: 0; list-style: none;
      }
      .step { display: flex; align-items: center; gap: 6px; }
      .dot {
        display: inline-block; flex-shrink: 0; width: 8px; height: 8px; border-radius: 999px;
        border: 1px solid var(--hr-strong, rgba(10, 10, 10, 0.12));
        background: transparent;
      }
      .step--done .dot { background: var(--c-green, #36AA75); border-color: var(--c-green, #36AA75); }
      .step--active .dot { background: var(--c-coral, #DF6662); border-color: var(--c-coral, #DF6662); }
      .label {
        font: 400 9.5px/1 var(--ui-mono, "JetBrains Mono", ui-monospace, monospace);
        letter-spacing: 0.14em;
        color: var(--ink-xlo, #B5B5B5);
      }
      .step--done .label { color: var(--c-green-deep, #2B7258); }
      .step--active .label { color: var(--ink-hi, #0A0A0A); }
      @media (prefers-reduced-motion: reduce) { * { scroll-behavior: auto !important; transition-duration: 0.01ms !important; } }
      @media (forced-colors: active) {
        header, nav { border-color: CanvasText; }
        .dot { border: 1px solid CanvasText; forced-color-adjust: none; }
        .step--done .dot, .step--active .dot { background: CanvasText; }
      }
    `;
        const header = document.createElement("header");
        const brand = document.createElement("div");
        brand.className = "brand";
        const mark = document.createElement("img");
        mark.className = "mark";
        mark.src = nodeMarkUrl;
        mark.alt = "Node";
        const wordmark = document.createElement("span");
        wordmark.className = "wordmark";
        wordmark.textContent = "CLIENT NODE";
        brand.append(mark, wordmark);
        const setup = document.createElement("span");
        setup.className = "setup";
        setup.textContent = "SETUP · ECON V1";
        header.append(brand, setup);
        const nav = document.createElement("nav");
        nav.setAttribute("aria-label", "Setup progress");
        const list = document.createElement("ol");
        list.className = "rail";
        const activeIndex = PHASE_INDEX[this.#phase];
        const allDone = this.#phase === "ready";
        for (const step of RAIL_STEPS) {
            const stepIndex = PHASE_INDEX[step.phase];
            const state = allDone
                ? "done"
                : stepIndex < activeIndex
                    ? "done"
                    : stepIndex === activeIndex
                        ? "active"
                        : "upcoming";
            const item = document.createElement("li");
            item.className = `step step--${state}`;
            if (state === "active")
                item.setAttribute("aria-current", "step");
            const dot = document.createElement("span");
            dot.className = "dot";
            dot.setAttribute("aria-hidden", "true");
            const label = document.createElement("span");
            label.className = "label";
            label.textContent = step.label;
            item.append(dot, label);
            list.append(item);
        }
        nav.append(list);
        root.append(style, header, nav);
    }
}
//# sourceMappingURL=onboarding-chrome.js.map